
import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Select } from 'antd'
import './style.less'
import { setFilter } from '@/store/slice/data'
import { initVal } from '@data/filter'
import * as order from '@data/order'

const { Option } = Select

const Filter = (props) => {
  const { type, name, choices } = props
  const dispatch = useDispatch()
  const filter = useSelector((state) => state.data.filter)
  const attr = useSelector((state) => state.data.filter[type])

  const onSelect = useCallback((val) => {
    dispatch(setFilter({ ...filter, [type]: val }))
  }, [dispatch, filter, type])

  const choiceList = useMemo(() => {
    if (!order[type]) return choices
    return choices.sort((a, b) => order[type][a] - order[type][b])
  }, [type, choices])

  return (
    <div className="Filter">
      <span className="text-nowrap">{name}：</span>
      <Select className="Filter-select" value={attr} onChange={onSelect}>
        {attr === initVal &&
          <Option value={initVal}>全部{name}</Option>
        }
        {choiceList.map(choice =>
          <Option key={choice} value={choice}>{choice}</Option>
        )}
      </Select>
    </div>
  )
}

export default Filter